export default {
    current_choice: 'Jelenlegi választás',
    book_now: 'Foglaljon most',
    minimum_age: 'Minimum kor: Csak ({age}) felett',
    excess_liability: 'Önrész kötelezettség',
    security_deposit: 'Biztonsági letét',
    fuel_policy: 'Üzemanyag irányelv',
    like_for_like: 'Kiadott üzemanyag szinttel megegyező mennyiséggel leadni',
    full_to_full: 'Kiadott üzemanyag szinttel megegyező mennyiséggel leadni',
    miles_per_rental: 'Km/bérlet: ({mileage}) engedélyezett kilométer-használat / bérlet',
    km_per_rental: 'Km/bérlet: ({mileage}) engedélyezett kilométer-használat / bérlet',
    unlimited_mileage: 'Korlátlan kilométer-használat',
    unlimited_mileage_km: 'Korlátlan km',
    non_amendable: 'Nem módosítható',
    non_refundable: 'Nem visszatérítendő',
    free_cancellation_until: 'Ingyenesen lemondható amíg: Ingyenes lemondás a következő időpontig',
    cancellation_in_line_with: 'Lemondás a következőkkel összhangban',
    tcs: 'Általános Szerződési Feltételek',
    free_extras_on_collection: 'Ingyenes extrák a csomagban: Kettő ingyenes extra a csomagban',
    glass_and_tyres_covered: 'Az üveg és a gumiabroncs fedezett',
    number_of_passengers: 'Az utasok száma',
    number_of_bags: 'A csomagok száma',
    fuel_type: 'Üzemanyag tipus',
    co2: 'CO2',
    aircon: 'légkondícionáló',
    transmission: 'Váltó',
    book_type: 'Foglalási {type}',
    debit_card_deposit: 'debit_card_deposit',
    fast_track_included: 'Fast Track tartalmazza',
}
